import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal, Chapter } from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";
import { useLang } from "@/i18n";

const PORTRAIT =
  "https://images.unsplash.com/photo-1604993995666-d8cef9e3b81f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxib2R5YnVpbGRlciUyMGNpbmVtYXRpYyUyMGd5bXxlbnwwfHx8fDE3ODgxOTAyNDl8MA&ixlib=rb-4.1.0&q=85";

const Story = () => {
  const { t } = useLang();
  const s = t.story;

  return (
    <section id="story" data-testid="story-section" className="py-24 md:py-32">
      <div className="container-x">
        <Chapter num="01" label={s.chapter} />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <Reveal>
              <div className="relative overflow-hidden border border-white/10 group">
                <motion.img
                  src={PORTRAIT}
                  alt="FitBersama"
                  className="w-full aspect-[3/4] object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/20" />
                <div className="absolute bottom-0 left-0 right-0 p-6 bg-black/60 backdrop-blur-sm border-t border-white/10">
                  <p className="font-display text-2xl uppercase tracking-wide">
                    {s.imgCaption}
                  </p>
                  <p className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] font-bold mt-1">
                    {s.imgSub}
                  </p>
                </div>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal>
              <h2 className="font-display text-4xl md:text-5xl lg:text-7xl uppercase tracking-tight leading-[0.9]">
                {s.titleA}{" "}
                <span className="text-[#D91624]">{s.titleB}</span> {s.titleC}
              </h2>
            </Reveal>

            <Reveal delay={0.1} className="mt-8 space-y-5 text-base md:text-lg text-neutral-400 leading-relaxed max-w-2xl">
              <p>{s.p1}</p>
              <p>
                <span className="text-white font-bold">{s.p2a}</span>
                {s.p2b}
              </p>
              <p>{s.p3}</p>
            </Reveal>

            <Reveal delay={0.2} className="mt-8 flex flex-wrap gap-4">
              {s.pillars.map((w) => (
                <span
                  key={w}
                  className="font-display text-2xl md:text-4xl uppercase tracking-wider border border-[#D4AF37]/40 text-[#D4AF37] px-5 py-2"
                >
                  {w}
                </span>
              ))}
            </Reveal>

            <Reveal delay={0.25} className="mt-10 border-l-2 border-[#D91624] pl-6 max-w-2xl">
              <p className="text-lg md:text-xl text-white font-semibold italic leading-relaxed">
                "{s.quote}"
              </p>
            </Reveal>

            <Reveal delay={0.3} className="mt-10">
              <button
                data-testid="story-join-btn"
                onClick={() => scrollToId("coaching")}
                className="btn-primary"
              >
                {s.cta} <ArrowRight size={16} />
              </button>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Story;
